module.exports = "<input #content\n       type=\"text\" [placeholder]=\"criteria.placeholder\"\n       (keyup)=\"criteriaChanged($event, crit)\"\n       [value]=\"getValue()\">\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/input/number-input/number-input.template.html
// module id = ./src/app/components/input/number-input/number-input.template.html
// module chunks = main